import { Box } from "@mui/material";
import DashboardGreeting from "./DashboardGreeting";
import DashboardGridLayout from "./DashboardGridLayout";
import DashboardOrders from "./orders/DashboardOrders";
import DashboardTalents from "./talents/DashboardTalents";
import HrTasklistContainer from "./tasklist/HrTasklistContainer";

const Dashboard = () => {
  return (
    <Box data-testid="dashboard-page-root">
      <DashboardGreeting />
      <DashboardGridLayout
        // TODO: add Interviews component to the top section
        top={<></>}
        left={<HrTasklistContainer />}
        right={[
          <DashboardTalents key="dashboardTalents" />,
          <DashboardOrders key="dahboardOrders" />,
        ]}
      />
    </Box>
  );
};

export default Dashboard;
